import { AsyncPipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import type { NonNullableFormBuilder } from '@angular/forms';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import type { OnyxFormMode, OnyxPhone } from '@onyx/angular';
import {
  OnyxAutoFocusDirective,
  OnyxDropdownComponent,
  OnyxPhoneNumberInputComponent,
  onyxPhoneValidator,
  OnyxSectionComponent,
  OnyxTextFieldComponent,
  onyxTextFieldLengthValidator,
} from '@onyx/angular';
import { DictionaryCode } from '../../../../../common/enums/dictionary-code';
import type { CompanyData } from '../../../../../common/interfaces/data-providers/company-data';
import { DictionariesService } from '../../../../../common/services/dictionaries.service';

type ContractorCompanyProfileFormGroup = ReturnType<
  (typeof ContractorCompanyProfileFormComponent)['buildForm']
>;

@Component({
  selector: 'app-contractor-company-profile-form',
  imports: [
    OnyxSectionComponent,
    ReactiveFormsModule,
    OnyxTextFieldComponent,
    OnyxDropdownComponent,
    AsyncPipe,
    OnyxPhoneNumberInputComponent,
    OnyxAutoFocusDirective,
  ],
  templateUrl: './contractor-company-profile-form.component.html',
  styleUrl: './contractor-company-profile-form.component.scss',
})
export class ContractorCompanyProfileFormComponent {
  private readonly dictionariesService = inject(DictionariesService);

  public readonly form = input.required<ContractorCompanyProfileFormGroup>();
  public readonly mode = input.required<OnyxFormMode>();
  public readonly companyData = input<CompanyData | null>();

  protected readonly I18N = 'contractors.contractorForm.companyProfile';

  protected readonly countries$ = this.dictionariesService.getVatIdCountries();
  protected readonly types$ = this.dictionariesService.getDictionary(
    DictionaryCode.CONTRACTOR_TYPE,
  );

  public static buildForm(fb: NonNullableFormBuilder) {
    return fb.group({
      companyName: fb.control<string | null>(null, [
        Validators.required,
        onyxTextFieldLengthValidator,
      ]),
      displayName: fb.control<string | null>(null, [
        Validators.required,
        Validators.maxLength(48),
      ]),
      country: fb.control({ value: '', disabled: true }, [Validators.required]),
      vatId: fb.control({ value: '', disabled: true }, [Validators.required]),
      types: fb.control<string[] | null>(null),
      phone: fb.control<OnyxPhone | null>(null, [onyxPhoneValidator]),
    });
  }
}
